import { utils } from '@easydata/core';
var InMemoryModelStorage = /** @class */ (function () {
    function InMemoryModelStorage(models) {
        this.models = [];
        if (models) {
            utils.assign(this.models, [], models);
        }
    }
    InMemoryModelStorage.prototype.getModels = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            resolve(_this.models);
        });
    };
    return InMemoryModelStorage;
}());
export { InMemoryModelStorage };
//# sourceMappingURL=model_storage.js.map